import { apiHttpService } from './apiHttpService';
import { ListResponse } from '../domains/app';
import { Achievement } from '../features/Achievements/achievements';
import { WorldEvent, WorldRecord } from '../features/WorldRecords/worldrecords';

export const fetchEvents = (): Promise<ListResponse<WorldEvent>> => {
  return apiHttpService
    .get(`/api/Achievement/events?page=0&pageSize=10000`)
    .then((response) => response.data);
};

export const fetchWorldRecords = (): Promise<ListResponse<WorldRecord>> => {
  return apiHttpService
    .get(`/api/Achievement/records?page=0&pageSize=10000`)
    .then((response) => response.data);
};

export const createWorldRecord = (a: WorldRecord): Promise<WorldRecord> => {
  return apiHttpService
    .post(`/api/Achievement/records`, a)
    .then((response) => response.data);
};

export const updateWorldRecord = (a: WorldRecord): Promise<WorldRecord> => {
  return apiHttpService
    .put(`/api/Achievement/records`, a)
    .then((response) => response.data);
};

export const deleteWorldRecord = (id: string): Promise<any> => {
  return apiHttpService
    .delete(`/api/Achievement/records/${id}`)
    .then((response) => response.data);
};

export const fetchListAchievements = (
  pageSize: number,
  page: number,
  personId: string,
  search?: string,
): Promise<Achievement[]> => {
  return apiHttpService
    .get(
      `/api/Achievement/person/${personId}?pageSize=${pageSize}&page=${page}${
        search ? `&searchValue=${search}` : ``
      }`,
    )
    .then((response) => response.data);
};

export const createAchievement = (a: Achievement): Promise<Achievement> => {
  return apiHttpService
    .post(`/api/Achievement`, a)
    .then((response) => response.data);
};

export const updateAchievement = (a: Achievement): Promise<Achievement> => {
  return apiHttpService
    .put(`/api/Achievement`, a)
    .then((response) => response.data);
};

export const deleteAchievement = (id: string): Promise<any> => {
  return apiHttpService
    .delete(`/api/Achievement/${id}`)
    .then((response) => response.data);
};

export const createAchievementRequest = (
  id: string,
  email: string,
): Promise<any> => {
  return apiHttpService
    .post(
      `/api/Achievement/${id}/confirm/request?email=${encodeURIComponent(
        email,
      )}`,
    )
    .then((response) => response.data);
};

export const fetchAchievementRequest = (personId: string): Promise<any> => {
  return apiHttpService
    .get(`/api/Achievement/confirm/confirming/${personId}`)
    .then((response) => response.data);
};

export const confirmAchievementRequest = (id: string): Promise<any> => {
  return apiHttpService
    .post(`/api/Achievement/confirm/${id}/accept`)
    .then((response) => response.data);
};

export const declineAchievementRequest = (id: string): Promise<any> => {
  return apiHttpService
    .post(`/api/Achievement/confirm/${id}/decline`)
    .then((response) => response.data);
};

// eslint-disable-next-line
export default {
  fetchEvents,
  fetchListAchievements,
  createAchievement,
  updateAchievement,
  deleteAchievement,
  fetchWorldRecords,
  createWorldRecord,
  updateWorldRecord,
  deleteWorldRecord,
  createAchievementRequest,
  fetchAchievementRequest,
  confirmAchievementRequest,
  declineAchievementRequest,
};
